
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SetNewPasswordForm from "./components/SetNewPasswordForm.vue";
import GeneralMessage from "@/components/deep-linking/GeneralMessage.vue";
import GeneralMessageModel from "@/models/deep-linking/GeneralMessageModel";
import { AxiosError } from "axios";
import { Emit } from "@/api/apiHelper";
import BaseView from "@/views/BaseView.vue";

@Component({
  components: { SetNewPasswordForm, GeneralMessage },
})
export default class ResetPassword extends BaseView {
  // 📦 The invitation token received from the email invite url
  private invitationToken: string | null = null;

  // 📦 The general message that needs to be displayed
  private generalMessage: GeneralMessageModel | null = null;

  // 🚩 Flag which determines whether a general message view should be displayed
  private showGeneralMessage: boolean = false;

  // 🚩 Flag which determines whether a set password view should be displayed
  private showSetNewPassword: boolean = false;

  protected async mounted() {
    this.invitationToken = this.$route.query.token.toString();
    this.validateRequestToken();
  }

  /**
   * 🔨 Shows a general message view
   */
  private showGeneralMessageView(
    title: string,
    message: string,
    buttonText?: string,
    buttonClickRoute?: string
  ) {
    this.generalMessage = new GeneralMessageModel(
      title,
      message,
      buttonText,
      buttonClickRoute
    );
    this.showGeneralMessage = true;
  }

  /**
   * 🚀 Validates the received password change token
   */
  private async validateRequestToken() {
    Vue.prototype.$api
      .get(
        "/api/v1/resetpassword",
        {
          token: this.invitationToken,
        },
        Emit.None
      )
      .then((response: any) => {
        this.showSetNewPassword = true;
      })
      .catch((error: AxiosError) => {
        switch (error.response?.status) {
          case 403:
            if (!error.response?.data.valid) {
              if (error.response?.data.expired) {
                this.showGeneralMessageView(
                  "Sorry, your request for changing your password is no longer valid",
                  "Don't worry, you can request it any time from our 'Forgot password' page",
                  "Take me there",
                  "/forgot-password"
                );
              } else {
                this.showGeneralMessageView(
                  "We could not find such password change request",
                  "Contact us if you need any assistance ✌"
                );
              }
              break;
            }
          default: {
            this.showErrorSnackbar(
              "Ops, something went wrong! We are investigating the problem! We are sorry for the inconvenience! ♥"
            );
          }
        }
      });
  }
}
